module.exports = __webpack_public_path__ + "2d108e4ed17fc0eaf5b4d750e5acd647.svg";